"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Snackbar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _lab = require("@material-ui/lab");

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Componente primário de interação com o usuário
 */
var Snackbar = function Snackbar(_ref) {
  var children = _ref.children,
      severity = _ref.severity,
      show = _ref.show,
      handleClose = _ref.handleClose,
      classes = _ref.classes,
      autoHideDuration = _ref.autoHideDuration,
      noClose = _ref.noClose;
  var defaultClasses = (0, _styles.useSnackStyles)();
  var customClasses = classes ? classes() : null;
  var snackbarStyle = customClasses ? customClasses.root : defaultClasses.root;
  var alertClasses = (0, _styles.useAlertStyles)();

  var _useState = (0, _react.useState)(show),
      _useState2 = _slicedToArray(_useState, 2),
      showAlert = _useState2[0],
      setShowAlert = _useState2[1];

  (0, _react.useEffect)(function () {
    if (autoHideDuration) {
      var alertTimer = setTimeout(function () {
        setShowAlert(false);
      }, autoHideDuration);
      return function () {
        return clearTimeout(alertTimer);
      };
    }

    return false;
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, noClose && showAlert && /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    classes: alertClasses,
    className: customClasses ? customClasses.root : '',
    severity: severity
  }, children), !noClose && /*#__PURE__*/_react.default.createElement(_core.Snackbar, {
    open: show,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    className: snackbarStyle,
    autoHideDuration: autoHideDuration,
    onClose: function onClose() {
      return handleClose && handleClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    onClose: function onClose() {
      return handleClose && handleClose();
    },
    severity: severity,
    classes: alertClasses
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: defaultClasses.colorText
  }, children))));
};

exports.Snackbar = Snackbar;
Snackbar.propTypes = {
  /**
   * Texto do Snackbar
   */
  children: _propTypes.default.string.isRequired,

  /**
   * Define a cor e o ícone do alerta
   */
  severity: _propTypes.default.oneOf(['error', 'warning', 'info', 'success']).isRequired,

  /**
   * Se 'true' o Snackbar é exibido
   */
  show: _propTypes.default.bool.isRequired,

  /**
   * Função para fechar o snackbar
   */
  handleClose: _propTypes.default.func,

  /**
   * Referência do hook makeStyles para gerar estilos
   */
  classes: _propTypes.default.func,

  /**
   * Quantidade de tempo, em milissegundos, que o snackbar ficará visível; funciona com noClose
   */
  autoHideDuration: _propTypes.default.number,

  /**
   * Se true, o snackBar nao possui o botao de fechar
   */
  noClose: _propTypes.default.bool
};
var _default = Snackbar;
exports.default = _default;
Snackbar.defaultProps = {
  handleClose: null,
  classes: null,
  autoHideDuration: null,
  noClose: false
};